import React from 'react';
import { Select } from 'antd';
import { SEND_THROUGH_LIST } from 'constants/common';
import { useCsvPerformanceStore } from './store';

const ESPs = [
  ...SEND_THROUGH_LIST.map(v => ({ value: v, label: v })),
  { value: '-1', label: 'Automatic' },
];

export default function ESPFilter() {
  const { selectedESPs, setSelectedESPs } = useCsvPerformanceStore();
  return (
    <Select
      mode="multiple"
      placeholder="filter ..."
      style={{ width: 20 }}
      value={selectedESPs}
      onChange={setSelectedESPs}
    >
      {ESPs.map(item => (
        <Select.Option key={item.label} value={item.value}>
          {item.label}
        </Select.Option>
      ))}
    </Select>
  );
}
